import { UUID } from "crypto"

// custom types for parsing data from the backend

export enum UserType {
    Guest = -1,
    User = 0,
    Artist = 1,
    Venue = 2,
    Admin = 3
}

export type JamPadEvent = {
    created_at: Date,
    creator: UUID,
    poster: string | null, // image url
    artist_ids: String[], // uuids
    artist_names: String[],
    description: string,
    price: number,
    private_event: boolean,
    
    saves: number,
    rsvps: number,
    likes: number,
    check_ins: number,
    rating_count: number,
    rating_sum: number,

    tags: String[],
    id: UUID,
    venue_id: UUID,
    verified: boolean,
    age: number,
    venue_verified: boolean,
    date: Date,
    end_date: Date,
    title: string,
    ticket_link: string,

    address: string,
    lat: number,
    lng: number,
    name: string,
    profile_id: UUID,
    private_venue: boolean,
    
    saved: boolean,
    rsvped: boolean,
    remind_hrs: number,
    pending_rsvp: boolean,
    liked: boolean,
    checked_in: boolean,

    rating: number,
    message: string,

    creator_username: string,
    creator_type: UserType,
    creator_pfp: string // url
}

export type JamPadProfile = {
    id: UUID,
    joined: Date,
    type: UserType,
    username: string,
    display_name: string,
    bio: string,
    followers: number,
    following: number,
    pfp: string | null, // url
    
    public_past: boolean,
    public_future: boolean, 
    user_following: boolean,
    following_user: boolean,
};

export type JamPadProfileSearchResult = {
    id: UUID,
    display_name: string,
    username: string,
    pfp: string | null,
    type: UserType
}

export type JamPadArtist = {
    id: UUID | null;
    name: string;
};